import {
  boolDialogCtrl
} from '../../../admin/modals';
// import {
//   AlertModalController
// } from '../alert-modal.component';
require('./rules-editor.component.scss');

export class RulesEditorController {
  constructor(
    $scope,
    $rootScope,
    $modalInstance,
    $modal,
    globalAlert,
    cut,
    ErrorHandlerService,
    CurrentModelService,
    $http,
    $window,
    $cookies,

  ) {
    this.scope = $scope;
    this.rootScope = $rootScope;
    this.$modal = $modal;
    this.$modalInstance = $modalInstance;
    this.globalAlert = globalAlert;
    this.$cookies = $cookies;

    this.scope.cut = cut;
    this.scope.rules = [];
    this.scope.term = {
      config: '',
      rule: '',
      useFilter: '',
      useFilterPrev: '',
    };
    this.globalRules = {};
    this.scope.label = CurrentModelService.model.getDrillLabel(cut.dimension);
    this.scope.sortConfigsDirection = 0;
    this.scope.sortRulesDirection = 0;
    this.$http = $http;
    this.window = angular.element($window);
    this.window.bind('resize', () => {
      const listBody = document.querySelector('.list-body>div');

      $('.list-body').height((window.innerHeight * 0.96 -
        $('.modal-header').outerHeight() -
        $('.list-head').outerHeight() -
        $('.modal-footer').outerHeight()));
      if (listBody) $('.toolbar-color>div').innerWidth(listBody.clientWidth);
    });

    this.scope.sortConfigs = () => {
      this.scope.sortConfigsDirection = this.scope.sortConfigsDirection === 1 ? -1 : this.scope.sortConfigsDirection + 1;
      this.sortConfigs();
    };
    this.scope.sortRules = () => {
      this.scope.sortRulesDirection = this.scope.sortRulesDirection === 1 ? -1 : this.scope.sortRulesDirection + 1;
      this.sortRules();
    };

    this.scope.useFilterClick = (useFilter) => {
      this.scope.term.useFilter = this.scope.term.useFilterPrev === useFilter ? '' : useFilter;
      this.scope.term.useFilterPrev = this.scope.term.useFilter;
      this.search();
    };

    this.scope.cancel = () => {
      $modalInstance.dismiss('cancel');
    };

    this.scope.search = () => this.search();

    this.scope.searchRulesClean = () => {
      this.scope.term.rule = '';
      this.search();
    };

    this.scope.searchConfigClean = () => {
      this.scope.term.config = '';
      this.search();
    };

    this.scope.saveRules = () => this.saveRules();

    this.scope.changeRule = (rule) => {
      if (rule.confId === 0) this.globalRules[rule.name] = rule.use !== 'not';
      this.search();
    };

    this.scope.hasGpobalRule = (rule) => rule.confId !== 0 && this.globalRules[rule.name];

    this.loadData();

  }

  sortRulesComare(a, b, whenEqual) {
    if (!this.scope.sortRulesDirection) return whenEqual;
    return (a.ruleDescription > b.ruleDescription ? 1 :
        a.ruleDescription === b.ruleDescription ? whenEqual : -1) *
      this.scope.sortRulesDirection;
  }

  sortConfigsComare(a, b, whenEqual) {
    if (!this.scope.sortConfigsDirection) return whenEqual;
    return (a.confDescription > b.confDescription ? 1 :
        a.confDescription === b.confDescription ? whenEqual : -1) *
      this.scope.sortConfigsDirection;
  }


  sortConfigs() {
    this.scope.rules.sort((a, b) => (
      this.sortConfigsComare(a, b, this.sortRulesComare(a, b, a.index - b.index))));
  }

  sortRules() {
    this.scope.rules.sort((a, b) => (
      this.sortRulesComare(a, b, this.sortConfigsComare(a, b, a.index - b.index))));
  }

  loadData() {
    let index = 0;
    this.$http.get('/analytics/configs/')
      .then((response) => {
        const config = response.data;
        config.map(conf => {
          const confId = conf.id;
          const confDescription = conf.name;
          conf.acl.map(rule => {
            if (!rule.dimensions.some(dm => dm === this.scope.cut.dimension)) {
              return;
            }

            const item = {
              confId,
              name: rule.name,
              confDescription,
              use: 'not',
              show: true,
              ruleDescription: rule.description,
              index: index++,
            };
            rule.rules.map(rl => {
              const value = rl.values.find(val => val.value === this.scope.cut.value);
              if (value) {
                item.valueId = value.id;
                if (item.confId === 0) this.globalRules[item.name] = true;
              }
              const nmArr = rl.name.split('_');
              const word = nmArr[nmArr.length - 1];
              switch (word) {
                case 'EXCLUDE':
                case 'BLACKLIST':
                  item.blockName = rl.name;
                  item.blockId = rl.id;
                  if (value) item.use = 'block';
                  break;
                default:
                  item.allowName = rl.name;
                  item.allowId = rl.id;
                  if (value) item.use = 'allow';
              }
            });
            item.useIntial = item.use;
            this.scope.rules.push(item);
          });
        });
        // this.search();
      });
  }

  search() {
    const regConfig = new RegExp(this.scope.term.config, 'i');
    const regRule = new RegExp(this.scope.term.rule, 'i');
    this.scope.rules.map(rule => {
      rule.show = rule.confDescription.search(regConfig) != -1 &&
        rule.ruleDescription.search(regRule) != -1 &&
        (this.scope.term.useFilter ? rule.use === this.scope.term.useFilter : true);
    });
    // this.hideWhenGlobalRule();
  }

  sort() {
    this.scope.rules.sort((a, b) => {
      const resConfig = a.confDescription > b.confDescription ? 1 :
        a.confDescription === b.confDescription ? 0 : -1;
      const resRule = a.ruleDescription > b.ruleDescription ? 1 :
        a.ruleDescription === b.ruleDescription ? 0 : -1;
      return resConfig * this.scope.sortConfigsDirection;
    });
  }

  saveRules() {
    const saveObj = {
      value: this.scope.cut.value,
    };
    this.scope.rules.filter(rule => rule.use !== rule.useIntial).map(rule => {
      // console.log(rule);
      if (!saveObj[rule.confId]) {
        saveObj[rule.confId] = {
          addToRule: [],
          delValue: []
        };
      }
      switch (rule.use) {
        case 'allow':

          saveObj[rule.confId].addToRule.push(rule.allowId);
          break;
        case 'block':
          saveObj[rule.confId].addToRule.push(rule.blockId);
          break;
      }
      if (rule.valueId) {
        saveObj[rule.confId].delValue.push(rule.valueId);
      }
    });
    if (Object.keys(saveObj).length < 2) {
      this.$modalInstance.close(null);
      return;
    }

    this.$http.post('/analytics/configs/save/', saveObj, {
        headers: {
          'X-CSRFToken': this.$cookies.get('csrftoken'),
        }
      })
      .then(result => {
        // console.log(result);
        this.$modalInstance.close(null);
      }, error => console.error(error));
  }

}



// WEBPACK FOOTER //
// ./src/filter/editor/rules-editor/rules-editor.component.js